import React from 'react';

import classNames from 'classnames';

import currencyFormat from '../../utils/currencyFormat';

import './sum-informer.scss';

interface SumInformerProps {
  lg?: boolean;
  red?: boolean;
  sum: number;
  title: string;
}

const SumInformer: React.FC<SumInformerProps> = ({ lg, red, sum, title }) => {
  const classPrefix = lg ? 'sum-informer-big' : 'sum-informer';

  return (
    <div
      className={classNames(classPrefix, {
        [`${classPrefix}--red`]: red,
      })}
    >
      <div className={`${classPrefix}__title`}>{title}</div>
      {lg && <div className={`${classPrefix}__subtitle`}>На сумму:</div>}
      <div className={`${classPrefix}__body`}>
        <div className={`${classPrefix}__sum`}>
          {currencyFormat(sum, false)}
          <span> ₽</span>
        </div>
      </div>
    </div>
  );
};

export default SumInformer;
